import React, { useState, useContext, useEffect, useRef } from 'react';
import { Icon, Tooltip, message, Input, Popconfirm } from 'antd';
import ElementsCategoryIcon from '../../images/elements-category.svg';
import TemplatesCategoryIcon from '../../images/templates-category.svg';
import FileDropdown from '../../components/FileDropdown';
import { DESIGN_AREA_SETTINGS_TAB } from './translationValues';
import { useTranslation } from 'react-i18next';

import {
  TabMenuContainer,
  SettingsList,
  SettingsHeading,
  SettingsListCard,
  SettingsListDetails,
  LoaderContainer,
  EmptySettingsDetails,
  SettingsCategoryOverview,
  HelpGuideWrapper,
  FileWrapper
} from './styles';

import Loader from '../../components/Loader';
import AddCategoryModal from '../../components/Modals/AddCategoryModal';
import UpdateCategoryModal from '../../components/Modals/UpdateCategoryModal';
import DeleteCategoryModal from '../../components/Modals/DeleteCategoryModal';
import { getAllCategories } from '../../utils/services/categoriesAPI';
import { changeTemplate } from '../../utils/services/templatesAPI';
// app store context API
import { AppStoreContext } from '../../context/appStoreContext';
import { ShortMsgTextContext } from '../../context/shortMessageContext';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];
const SettingsTabDetails = props => {
  const [selectedSettings, setSelectedSettings] = useState('manage-studio');
  const { t } = useTranslation(NAMESPACES);
  const [fetchingCategories, setFetchingCategories] = useState(false);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [activeElement, setActiveElement] = useState(false);
  const {
    updateCategoryElements,
    updateCategoryTemplates,
    categoryTemplates,
    categoryElements,
    userDetails
  } = useContext(AppStoreContext);
  const shortMessageContext = useContext(ShortMsgTextContext);
  const [categoryTemplate, setcategoryTemplates] = useState(null);
  const [categoryElement, setcategoryElements] = useState(null);
  const inputRef = useRef(null);

  const userType = userDetails.userType;
  let tempDetails;
  if (shortMessageContext) {
    tempDetails = shortMessageContext.tempDetails;
  }

  useEffect(() => {
    if (selectedSettings === 'elements-category') {
      let loggedUserElementCategory = categoryElements.filter(
        categoryObj => userType === categoryObj.categoryusertype,
      );
      setcategoryElements(loggedUserElementCategory);
    } else {
      const loggedUserCategory = categoryTemplates.filter(
        categoryObj => userType === categoryObj.categoryusertype,
      );
      setcategoryTemplates(loggedUserCategory);
    }
    // eslint-disable-next-line
  }, [selectedSettings, categoryTemplates, categoryElements]);

  const setSelection = selectionType => {
    if (selectionType === 'elements-category') {
      (async () => {
        setSelectedSettings(selectionType);
        setFetchingCategories(true);
        const response = await getAllCategories(true);
        if (response && response.data) {
          updateCategoryElements(response.data, 'saveAllCategoryElements');
        }
        setFetchingCategories(false);
      })();
    } else if (selectionType === 'templates-category') {
      (async () => {
        setSelectedSettings(selectionType);
        setFetchingCategories(true);
        const response = await getAllCategories(false, 'template');
        if (response && response.data) {
          updateCategoryTemplates(response.data, 'saveAllCategoryTemplates');
        }
        setFetchingCategories(false);
      })();
    }
    else {
      setSelectedSettings(selectionType);
      setFetchingCategories(false);
    }
  };

  const enableModalVisibility = (actionType, category) => {
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);
    setSelectedCategory(category);
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setSelectedAction(null);
    setSelectedCategory(null);
  };

  const focusInput = (e) => {
    e.preventDefault();
    e.stopPropagation();
    inputRef.current.focus();
    if (inputRef.current.state.value !== props.templates?.displayName) {
      setShowConfirm(true);
    }
  };

  const changeDocumentName = async() =>{
    let payload = {};
    payload.id = props.templates.id;
    payload.displayName = inputRef.current.state.value;
    let response = await changeTemplate(payload);
    if (response) {
      if (response.errors.length === 0) {
        props.onTemplateSave({ ...props.templates, displayName: payload.displayName }, true);
        message.success(response.status);
      } else {
        message.error(response.status);
      }
    }
    setShowConfirm(false);
    setActiveElement(false);
  }

  const renderSuffix = () => {
    if (activeElement || showConfirm) {
     return (
       <Tooltip
         placement="right"
         title={
          showConfirm
            ? t(DESIGN_AREA_SETTINGS_TAB.SAVE_FILE_NAME_TOOLTIP.key, DESIGN_AREA_SETTINGS_TAB.SAVE_FILE_NAME_TOOLTIP.value)
            : t(DESIGN_AREA_SETTINGS_TAB.EDIT_FILE_NAME_TOOLTIP.key, DESIGN_AREA_SETTINGS_TAB.EDIT_FILE_NAME_TOOLTIP.value)
        }
       >
         <Icon
           type={showConfirm ? 'check-circle' : "edit"}
           theme={showConfirm && 'filled'}
           style={{
             color: 'rbg(43, 42, 53)',
             fontSize: '18px',
           }}
           onClick={showConfirm ? changeDocumentName : focusInput}
         />
       </Tooltip>
     );
    }
    return null;
  }

  return (
    <TabMenuContainer>
      {selectedSettings && selectedSettings === 'manage-studio' && (
        <SettingsList>
          {!props.isShortMessageTemp && !props.isEmailTemp && !props.isRefElement && (
            <>
              <SettingsHeading docName={1}>{t(DESIGN_AREA_SETTINGS_TAB.FILE_NAME_LABEL.key, DESIGN_AREA_SETTINGS_TAB.FILE_NAME_LABEL.value)}</SettingsHeading>
              <div>
                <Input
                  defaultValue={props.templates.displayName}
                  ref={inputRef}
                  onBlur={(e) => {
                    if (e.relatedTarget?.parentElement.className !== 'ant-input-suffix') {
                      setActiveElement(false);
                    }
                  }}
                  onFocus={() => {
                    setActiveElement(true);
                    setTimeout(() => {
                      inputRef.current.focus();
                    }, 0);
                  }}
                  style={{ marginTop: '10px', marginBottom: '20px' }}
                  suffix={renderSuffix()}
                  onChange={() => setShowConfirm(true)}
                />
                <Popconfirm
                  title={t(DESIGN_AREA_SETTINGS_TAB.FILE_NAME_CHANGE_CONFIRMATION.key, DESIGN_AREA_SETTINGS_TAB.FILE_NAME_CHANGE_CONFIRMATION.value)}
                  onConfirm={changeDocumentName}
                  onCancel={() => setShowConfirm(false)}
                  okText={t(DESIGN_AREA_SETTINGS_TAB.UPDATE_FILE_NAME_YES_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.UPDATE_FILE_NAME_YES_BUTTON.value)}
                  cancelText={t(DESIGN_AREA_SETTINGS_TAB.CANCEL_UPDATE_FILE_NAME_NO_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.CANCEL_UPDATE_FILE_NAME_NO_BUTTON.value)}
                />
              </div>
            </>
          )}
          <SettingsHeading>{t(DESIGN_AREA_SETTINGS_TAB.MANAGE_STUDIO_TITLE.key, DESIGN_AREA_SETTINGS_TAB.MANAGE_STUDIO_TITLE.value)}</SettingsHeading>
          {!props.isShortMessageTemp && (
            <SettingsListCard onClick={() => setSelection('elements-category')}>
              <div className="settings-list-icon">
                <img src={ElementsCategoryIcon} alt="ElementsCategoryIcon" />
              </div>
              <div className="settings-list-meta">
                <div className="settings-list-name">{t(DESIGN_AREA_SETTINGS_TAB.ELEMENT_CATEGORY_TITLE.key, DESIGN_AREA_SETTINGS_TAB.ELEMENT_CATEGORY_TITLE.value)}</div>
                <div className="settings-list-details">{t(DESIGN_AREA_SETTINGS_TAB.ELEMENT_CATEGORY_DESCRIPTION.key, DESIGN_AREA_SETTINGS_TAB.ELEMENT_CATEGORY_DESCRIPTION.value)}</div>
              </div>
            </SettingsListCard>
          )}
          {!props.isRefElement &&
            < SettingsListCard onClick={() => setSelection('templates-category')}>
              <div className="settings-list-icon">
                <img src={TemplatesCategoryIcon} alt="TemplatesCategoryIcon" />
              </div>
              <div className="settings-list-meta">
                <div className="settings-list-name">{t(DESIGN_AREA_SETTINGS_TAB.TEMPLATE_CATEGORY_TITLE.key, DESIGN_AREA_SETTINGS_TAB.TEMPLATE_CATEGORY_TITLE.value)}</div>
                <div className="settings-list-details">{t(DESIGN_AREA_SETTINGS_TAB.TEMPLATE_CATEGORY_DESCRIPTION.key, DESIGN_AREA_SETTINGS_TAB.TEMPLATE_CATEGORY_DESCRIPTION.value)}</div>
              </div>
            </SettingsListCard>
          }
          <SettingsListCard onClick={() => setSelection('files')}>
            <div className="settings-list-icon">
              <Icon type="file" />
            </div>
            <div className="settings-list-meta">
              <div className="settings-list-name">{t(DESIGN_AREA_SETTINGS_TAB.FILES_TITLE.key, DESIGN_AREA_SETTINGS_TAB.FILES_TITLE.value)}</div>
              <div className="settings-list-details">{t(DESIGN_AREA_SETTINGS_TAB.FILES_DESCRIPTION.key, DESIGN_AREA_SETTINGS_TAB.FILES_DESCRIPTION.value)}</div>
            </div>
          </SettingsListCard>
        </SettingsList>
      )
      }
      {
        selectedSettings && selectedSettings === 'elements-category' && (
          <SettingsListDetails>
            <SettingsHeading className="with-icon">
              <Icon type="left" onClick={() => setSelectedSettings('manage-studio')} /> {t(DESIGN_AREA_SETTINGS_TAB.ELEMENT_CATEGORY_TITLE.key, DESIGN_AREA_SETTINGS_TAB.ELEMENT_CATEGORY_TITLE.value)}
              {!fetchingCategories && categoryElement.length > 0 && `(${categoryElement.length})`}
            </SettingsHeading>
            {fetchingCategories && (
              <LoaderContainer>
                <Loader />
                <div className="loading-txt">{t(DESIGN_AREA_SETTINGS_TAB.LOADING_SETTINGS.key, DESIGN_AREA_SETTINGS_TAB.LOADING_SETTINGS.value)}</div>
              </LoaderContainer>
            )}
            {!fetchingCategories && categoryElement.length === 0 && (
              <EmptySettingsDetails>
                  <div className="empty-txt">
                    <span>{t(DESIGN_AREA_SETTINGS_TAB.CATEGORIES_LIST_EMPTY.key, DESIGN_AREA_SETTINGS_TAB.CATEGORIES_LIST_EMPTY.value)}</span>
                    <span
                      className="empty-links"
                      onClick={() => enableModalVisibility('add-category', null)}
                    >
                      {t(DESIGN_AREA_SETTINGS_TAB.HERE.key, DESIGN_AREA_SETTINGS_TAB.HERE.value)}
                    </span>
                    <span>{t(DESIGN_AREA_SETTINGS_TAB.CREATE_NEW_CATEGORY.key, DESIGN_AREA_SETTINGS_TAB.CREATE_NEW_CATEGORY.value)}</span>
                  </div>
              </EmptySettingsDetails>
            )}
            {!fetchingCategories && categoryElement.length > 0 && (
              <>
                {categoryElement.map((category, index) => (
                  <SettingsCategoryOverview key={category.id}>
                    <>
                      <div className="category-overview-name" title={category.name}>
                        {index + 1}. {category.name}
                      </div>
                      <div className="category-overview-actions">
                          <div
                            className="category-action"
                            onClick={() => enableModalVisibility('edit-category', category)}
                          >
                            <Tooltip title={t(DESIGN_AREA_SETTINGS_TAB.EDIT_CATEGORY_TOOLTIP.key, DESIGN_AREA_SETTINGS_TAB.EDIT_CATEGORY_TOOLTIP.value)}>
                              <Icon type="edit" />
                            </Tooltip>
                          </div>
                          <div
                            className="category-action"
                            onClick={() => enableModalVisibility('delete-category', category)}
                          >
                            <Tooltip title={t(DESIGN_AREA_SETTINGS_TAB.DELETE_CATEGORY_TOOLTIP.key, DESIGN_AREA_SETTINGS_TAB.DELETE_CATEGORY_TOOLTIP.value)}>
                              <Icon type="delete" />
                            </Tooltip>
                          </div>
                      </div>
                    </>
                  </SettingsCategoryOverview>
                ))}
              </>
            )}
          </SettingsListDetails>
        )
      }
      {
        selectedSettings && selectedSettings === 'templates-category' && (
          <SettingsListDetails>
            <SettingsHeading className="with-icon">
              <Icon type="left" onClick={() => setSelectedSettings('manage-studio')} /> {t(DESIGN_AREA_SETTINGS_TAB.TEMPLATE_CATEGORY_TITLE.key, DESIGN_AREA_SETTINGS_TAB.TEMPLATE_CATEGORY_TITLE.value)}
              {!fetchingCategories && categoryTemplate.length > 0 && `(${categoryTemplate.length})`}
            </SettingsHeading>
            {fetchingCategories && (
              <LoaderContainer>
                <Loader />
                <div className="loading-txt">{t(DESIGN_AREA_SETTINGS_TAB.LOADING_SETTINGS.key, DESIGN_AREA_SETTINGS_TAB.LOADING_SETTINGS.value)}</div>
              </LoaderContainer>
            )}
            {!fetchingCategories && categoryTemplate.length === 0 && (
              <EmptySettingsDetails>
                  <div className="empty-txt">
                    <span>{t(DESIGN_AREA_SETTINGS_TAB.CATEGORIES_LIST_EMPTY.key, DESIGN_AREA_SETTINGS_TAB.CATEGORIES_LIST_EMPTY.value)}</span>
                    <span
                      className="empty-links"
                      onClick={() => enableModalVisibility('add-category', null)}
                    >
                      {t(DESIGN_AREA_SETTINGS_TAB.HERE.key, DESIGN_AREA_SETTINGS_TAB.HERE.value)}
                    </span>
                    <span>{t(DESIGN_AREA_SETTINGS_TAB.CREATE_NEW_CATEGORY.key, DESIGN_AREA_SETTINGS_TAB.CREATE_NEW_CATEGORY.value)}</span>
                  </div>
              </EmptySettingsDetails>
            )}
            {!fetchingCategories && categoryTemplate.length > 0 && (
              <>
                {categoryTemplate.map((category, index) => (
                  <SettingsCategoryOverview key={category.id}>
                    <div className="category-overview-name" title={category.name}>
                      {index + 1}. {category.name}
                    </div>
                    <div className="category-overview-actions">
                        <div
                          className="category-action"
                          onClick={() => enableModalVisibility('edit-category', category)}
                        >
                          <Tooltip title={t(DESIGN_AREA_SETTINGS_TAB.EDIT_CATEGORY_TOOLTIP.key, DESIGN_AREA_SETTINGS_TAB.EDIT_CATEGORY_TOOLTIP.value)}>
                            <Icon type="edit" />
                          </Tooltip>
                        </div>
                        <div
                          className="category-action"
                          onClick={() => enableModalVisibility('delete-category', category)}
                        >
                          <Tooltip title={t(DESIGN_AREA_SETTINGS_TAB.DELETE_CATEGORY_TOOLTIP.key, DESIGN_AREA_SETTINGS_TAB.DELETE_CATEGORY_TOOLTIP.value)}>
                            <Icon type="delete" />
                          </Tooltip>
                        </div>
                    </div>
                  </SettingsCategoryOverview>
                ))}
              </>
            )}
          </SettingsListDetails>
        )
      }
      {
        selectedSettings && selectedSettings === 'files' && (
          <SettingsListDetails>
            <SettingsHeading className="with-icon">
              <Icon type="left" onClick={() => setSelectedSettings('manage-studio')} />{t(DESIGN_AREA_SETTINGS_TAB.FILES_TITLE.key, DESIGN_AREA_SETTINGS_TAB.FILES_TITLE.value)}{' '}
            </SettingsHeading>
              <FileDropdown template={props.templates}
                isRefElement={props.isRefElement}
                shortMsgTempDetails={tempDetails}
                isEmailTemp={props.isEmailTemp} 
                isShortMessageTemp={props.isShortMessageTemp} />
              <FileWrapper onClick={e => e.preventDefault()}>
              </FileWrapper>
          </SettingsListDetails>
        )
      }
      {
        !fetchingCategories &&
        selectedSettings &&
        (selectedSettings === 'elements-category' || selectedSettings === 'templates-category') && (
          <HelpGuideWrapper>
            <div className="help-container">
              <div
                className="help-action-btn"
                onClick={() => enableModalVisibility('add-category', null)}
              >
                <Icon type="plus" />{t(DESIGN_AREA_SETTINGS_TAB.ADD_CATEGORY_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.ADD_CATEGORY_BUTTON.value)}
              </div>
            </div>
          </HelpGuideWrapper>
        )
      }
      {
        !fetchingCategories &&
        updateModalVisibility &&
        selectedAction &&
        selectedAction === 'add-category' && (
          <AddCategoryModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            categoryType={
              selectedSettings && selectedSettings === 'elements-category' ? 'element' : 'template'
            }
          />
        )
      }
      {
        !fetchingCategories &&
        updateModalVisibility &&
        selectedAction &&
        selectedAction === 'edit-category' && (
          <UpdateCategoryModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            categoryType={
              selectedSettings && selectedSettings === 'elements-category' ? 'element' : 'template'
            }
            categoryDetails={selectedCategory}
          />
        )
      }
      {
        !fetchingCategories &&
        updateModalVisibility &&
        selectedAction &&
        selectedAction === 'delete-category' && (
          <DeleteCategoryModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            categoryType={
              selectedSettings && selectedSettings === 'elements-category' ? 'element' : 'template'
            }
            targetElement={selectedCategory}
          />
        )
      }
    </TabMenuContainer >
  );
};

export default SettingsTabDetails;
